(function() {

    var globals = require("./modules/globals.js");
    var analyse = require("./modules/analyse.js");
    var timeline = require("./timeline.js");
    
    module.exports = {
	eventClick: eventClick,
	personClick: personClick,
    }

    function eventClick(d) {
	console.log("eventClick")
	if(d.startDate != '') {
	    eventDate = d.startDate + " to " + d.endDate;
	} else {
	    eventDate = d.date;
	}

	$(".info-container").remove();
	
	eventData = {
	    name: d.eventName,
	    image: d.image,
	    venue: d.venue,
	    location: d.location,
	    notes: d.notes,
	    category: d.eventType,
	    pSource: d.pSource,
	    sSource: d.sSource,
	    date: eventDate,
//	    color:globals.units.color(eventTypes[d.eventType].color),
	    id:d.id
	}

	eventX = positionInfo(d.x,'x');
	eventY = positionInfo(d.y,'y');
	console.log("eventClick")
	
	$.ajax({
	    url:'templates/eventInfo.html',
	    cache:false,
	}).done(function(data) {
	    $('body').append(Mustache.render(data, eventData));
	    $(".info-container").css("left", eventX+"px").css("top", eventY+"px")
	    $(".info-container").fadeIn();
	    $(".close-btn").click(function() {
		$(this).parent().parent().fadeOut(500, function() { $(this).remove() });
	    });
	    $(".action-btn").click(function() {
		console.log($(this).parent().parent().attr("data-eventid"))
		el = analyse.findAttendees($(this).parent().parent().attr("data-eventid"), globals._data);
		globals._data.nodesData.concat(el.nodes)
		globals._data.linksData.concat(el.links);
		timeline.updateNetwork();
	    });
	});
    }

    function personClick(d) {
	$(".info-container").remove();
	eventX = positionInfo(d.x,'x');
	eventY = positionInfo(d.y,'y');

	if(d.relProtagonist == '') {
	    d.relProtagonist = 'unkown relation';
	}
	
	person = {
	    id: d.id,
	    name: d.name,
	    relationship: d.relProtagonist,
	    protagonist: protagonists[d.datasets[0]] + "'s ",
	    residence: d.residence,
	    bio: d.bioEn,
	    party: d.party,
	    proffesion: d.proffesion,
	}
	
	$.ajax({
	    url:'templates/personInfo.html',
	    cache:false,
	}).done(function(data) {
	    $('body').append(Mustache.render(data, person));
	    $(".info-container").css("left", eventX+"px").css("top", eventY+"px")
	    $(".info-container").fadeIn();
	    $(".close-btn").click(function() {
		$(this).parent().parent().fadeOut(500, function() { $(this).remove() });
	    });
	    $(".action-btn").click(function() {
//		showAttendees($(this).parent().parent().attr("data-eventid"));
	    });
	}); 
    }

    var posVals = {x:{edge:555, offset:550},y:{edge:300, offset:250}}
    
    function positionInfo(val, axis) {
	
/*	if(val > posVals[axis].edge) {
	    eventPos = val - posVals[axis].offset
	} else {
	    eventPos = val + 50;
	}*/
	return val > posVals[axis].edge ? val - posVals[axis].offset : val + 50;
//	return eventPos
    }
    
})();
